export const getHostname = (url) => {
  if (!url) return "";
  const anchor = document.createElement("a");
  anchor.href = url;
  return anchor.hostname;
};
